<div class="vos-selection">
  <div class="vos-row">
    <div class="vos-row__scope">
      <span class="vos-row__name">All clients</span>
      @if (isLoaded) {
        <span class="vos-row__count">
          {{ selected.length }}
          {{ selected.length === 1 ? singular : plural }}
        </span>
      }
    </div>

    @if (!isLoaded) {
      <p class="vos-row__empty">Loading…</p>
    } @else if (selected.length === 0) {
      <p class="vos-row__empty">No operating {{ plural }} selected</p>
    } @else {
      <div class="vos-row__tags">
        @for (division of selected; track division.id) {
          <span
            class="vos-tag"
            [class.vos-tag--required]="division.clientNames.length > 0"
            [attr.title]="getRequirementTitle(division)"
          >
            @if (division.clientNames.length > 0) {
              <i class="bi bi-shield-check vos-tag__marker"></i>
              <span class="visually-hidden">
                {{ getRequirementTitle(division) }}:
              </span>
            }
            {{ division.name }}
            @if (canEdit) {
              <button
                type="button"
                class="vos-tag__remove"
                [title]="'Remove ' + division.name"
                [attr.aria-label]="'Remove ' + division.name"
                (click)="removeState(division)"
              >
                <i class="bi bi-x-lg"></i>
              </button>
            }
          </span>
        }
      </div>
    }

    @if (isLoaded && canEdit) {
      <button
        type="button"
        class="btn btn-ghost btn-sm vos-row__action"
        (click)="chooseStates()"
      >
        @if (selected.length === 0) {
          <i class="bi bi-plus-lg me-1"></i>
          Select {{ plural }}
        } @else {
          <i class="bi bi-pencil me-1"></i>
          Edit {{ plural }}
        }
      </button>
    }
  </div>
</div>
